module.exports = __webpack_public_path__ + "media/images/theme/generic/bg-navbar-da87cc5bdfc3f1e0b75eae7810d4a240.png";